<div
    class="relative w-screen h-full overflow-x-hidden text-pretty">

    <div class="relative w-[100vw] h-[90vh] before:absolute before:inset-0 before:bg-gradient-to-r before:from-black/80 before:to-black/10">
        @if (introImage) {
            <img [src]="introImage" alt="" class="w-[100vw] h-[90vh] object-cover" />
        }
    </div>

    <div class="absolute inset-0 flex flex-col justify-center h-[80vh] px-4 sm:pl-[18%] text-2xl sm:text-3xl text-white sm:w-[50vw]">
        <p class="font-semibold font-jakarta">{{ siteDetails?.homePageTitle }}</p>
        <common-button theme="pumpkin" class="py-8" icon="arrow_full" [reversed]="true" iconSize="XL"
            routerLink="/general/about-us">
            <span class="text-nowrap">
                Read More
            </span>
        </common-button>
    </div>

    <section class="px-[10%] flex flex-col sm:flex-row py-8 gap-3 sm:gap-8">
        @if (banner) {
            <img [src]="banner" alt="" class="max-h-[400px]">
        }
        <div class="flex flex-col gap-8 py-2 sm:py-8 sm:w-[50%]">
            <p class="title font-jakarta text-2xl ">{{ siteDetails?.homePageTitle }}</p>
            <p>{{ siteDetails?.homePageDescription }}</p>
            <common-button theme="pumpkin" icon="arrow_full" [reversed]="true" iconSize="XL"
                routerLink="/general/about-us">
                <span class="text-nowrap">
                    Read More
                </span>
            </common-button>
        </div>
    </section>

    <section class="flex flex-col items-center gap-8 py-8 bg-[var(--background-secondary)]">
        <p class="title font-jakarta text-2xl text-center">Upcoming Events</p>
        @if (events.length) {
            <div class="flex gap-4 w-full justify-center mx-4">
                @for (event of events; track event.id) {
                    <div
                        class="flex flex-col w-[98%] sm:w-[388px] bg-[var(--background-primary-color)] rounded-md gap-3 py-3">
                        <p class="text-lg font-semibold px-3 font-jakarta ">{{ event.name }}</p>
                        <div class="flex flex-row gap-2 px-3">

                            <span class="truncate text-sm/5 flex items-center gap-1">
                                <svg-icon name="calendar" size="XS" color="var(--text-primary)">
                                </svg-icon>
                                {{ event.dateLabel }}
                            </span>

                            <span class="truncate text-sm/5 flex items-center gap-1">
                                <svg-icon name="clock" size="XS" color="var(--text-primary)">
                                </svg-icon>
                                {{ event.timeLabel }}
                            </span>
                        </div>

                        <div class="flex gap-2">
                            <span
                                class="bg-[var(--bg-label-yellow)] text-[var(--label-yellow)] self-start text-sm inline-block px-4 py-[5px] rounded-[4px] ml-3">
                                {{ event?.participantsLabel }}
                            </span>

                            @if (event?.activeDiscounts) {
                                <span
                                    class="flex gap-1 items-center bg-[var(--bg-success)] text-[var(--accent-success)] self-start text-sm inline-block px-3 py-[3px] rounded-[4px] ">
                                    Discounts Available
                                    <svg-icon name="discount" color="var(--accent-success)"></svg-icon>
                                </span>
                            }
                        </div>

                        <div class="h-[200px] sm:h-[215px]">
                            <image [id]="event.file?.id"></image>
                        </div>

                        <p class="pb-1 px-3 text-[var(--link)] cursor-pointer text-lg font-dmsans"
                            [routerLink]="['/event-details/' + event.id]">Learn More
                        </p>
                    </div>
                }
            </div>
            <common-button theme="pumpkin" icon="arrow_full" [reversed]="true" iconSize="XL"
                routerLink="/general/events">Explore More
            </common-button>
        } @else {
            <div class="flex flex-col items-center gap-2">
                <img src="../../../assets/image-placeholders/no_events.png" alt="" class="w-[120px] opacity-40">
                <p class="title">No Events To Show</p>
            </div>
        }
    </section>

    <section class="flex flex-col items-center gap-8 py-8 bg-[var(--white)] sm:px-[9%]">
        <p class="title font-jakarta text-2xl text-center">Our Flexible Membership Plans</p>

        <div class="flex flex-row flex-wrap gap-4 justify-center w-[100%]">
            @for (membership of memberships; track membership.id; let idx = $index) {
                @if (idx < 6 || showAll) {
                    <div class="flex flex-row justify-between gap-4 bg-[var(--bg-lightblue)] rounded p-4 w-full sm:min-w-[400px] sm:w-[45%]">
                        <div class="flex flex-col gap-1">
                            <p class="title font-jakarta">{{ membership.title }}</p>
                            <p class="font-dmsans">
                                {{ membership.price ? 'Starts from $' + membership.price : 'Free' }}
                            </p>
                        </div>

                        <div class="flex flex-col gap-1 mt-1">
                            <common-button theme="pumpkin" class="text-nowrap" icon="arrow_full" [reversed]="true"
                                (click)="purchaseMembership(membership.id)" iconSize="XL">Buy Now
                            </common-button>

                            <p class="pb-1 px-3 text-[var(--link)] cursor-pointer text-sm font-dmsans"
                            routerLink="/general/memberships"
                            >More Details</p>
                        </div>
                    </div>
                }
            }
        </div>

        @if (memberships.length > 6) {
            <p class="text-[var(--link)] cursor-pointer text-sm font-dmsans self-end pr-[5%]"
                (click)="showAll = !showAll" (keypress)="{}" tabindex="0">
                Show {{ showAll ? 'Less' : 'More' }}
            </p>
        }
    </section>

    <section
        class="flex flex-col justify-center items-center gap-7 py-10 text-pretty bg-[var(--link)] text-[var(--white)] px-4">
        <p class="title font-jakarta text-2xl text-[var(--white)] text-center">Your Contribution can make a Difference Today</p>
        <p class="text-center">
            Every donation helps us strengthen our community and keep our traditions alive
        </p>
        <common-button theme="pumpkin" icon="arrow_full" [reversed]="true" iconSize="XL" routerLink="/general/donation">
            Donate Now
        </common-button>
    </section>

    <contact-us-form class="w-full"></contact-us-form>

    <secondary-footer></secondary-footer>
</div>
